import React from 'react'

export function usePrevious(value: any) {
    const ref = React.useRef(value)

    React.useEffect(() => {
        ref.current = value
    })

    return ref.current
}
